import { baseService } from "./base";

const varzService = {
  get() {
    return baseService.get("/api/varz");
  },
};

export default varzService;
